import { ref } from "vue";
import { defineStore } from "pinia";
import isSpacedString from "@/helpers/isSpacedString";

import type { User } from "@/modules/users/interfaces/user";

export const useUserSearchStore = defineStore("userSearch", () => {
  const query = ref("");
  const users = ref<User[]>([]);

  return {
    query,
    users,

    setQuery(value: string) {
      if (!isSpacedString(value)) {
        query.value = value;
      }
    },
    setUsers(value: User[] | undefined) {
      users.value = value || [];
    },
    resetState() {
      query.value = "";
      users.value = [];
    },
  };
});